export default __webpack_public_path__ + "static/media/Questionador.7e70f1f3.svg";